import React, { useRef, useState } from "react";
import { Lock, Loader2, ShieldCheck, AlertTriangle, LogOut, Upload } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Mostrato quando l'utente è autenticato (token presente) ma il file chiave non
// è disponibile in questa scheda (la chiave è tenuta per-tab in sessionStorage).
// Ricaricando il file chiave la sessione viene sbloccata in memoria.
export default function VaultUnlock() {
  const { unlock, logout, user } = useAuth();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [fileName, setFileName] = useState("");
  const inputRef = useRef(null);

  const onFile = async (f) => {
    if (!f) return;
    setBusy(true); setErr(""); setFileName(f.name);
    try {
      const text = await f.text();
      let kf;
      try { kf = JSON.parse(text); } catch { throw new Error("Il file non è un JSON valido"); }
      await unlock(kf);
    } catch (ex) {
      setErr(ex.message || "Sblocco fallito");
    } finally {
      setBusy(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-[#050505]/95 px-5 backdrop-blur-sm" data-testid="vault-unlock">
      <div className="w-full max-w-sm border border-[#262626] bg-[#0a0a0a] p-7 lt-glow-primary">
        <div className="flex flex-col items-center text-center">
          <div className="flex h-12 w-12 items-center justify-center border lp-bd40 lp-b10">
            <Lock className="h-6 w-6 lp-c" />
          </div>
          <h2 className="mt-4 font-display text-xl font-700">Carica il file chiave</h2>
          <p className="mt-2 text-sm text-[#a3a3a3]">
            Per leggere e inviare messaggi cifrati in questa scheda serve il tuo file chiave.
            {user?.lns && <span className="mt-1 block font-mono text-[11px] lp-c">{user.lns}</span>}
          </p>
        </div>
        {err && (
          <div className="mt-4 flex items-center gap-2 border border-[#ff3333]/40 bg-[#ff3333]/10 p-3 text-sm text-[#ff9a9a]" data-testid="vault-unlock-error">
            <AlertTriangle className="h-4 w-4" /> {err}
          </div>
        )}
        <input ref={inputRef} type="file" accept="application/json,.json" hidden onChange={(e) => onFile(e.target.files?.[0])} data-testid="vault-unlock-file-input" />
        <button onClick={() => inputRef.current?.click()} disabled={busy} data-testid="vault-unlock-submit"
          className="mt-5 flex w-full items-center justify-center gap-2 border lp-bd lp-b py-3.5 font-mono text-sm uppercase tracking-wider text-white hover:bg-[#3fa862] disabled:opacity-60">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Upload className="h-4 w-4" /> Seleziona file chiave</>}
        </button>
        {fileName && !busy && !err && (
          <p className="mt-3 flex items-center justify-center gap-1.5 font-mono text-[11px] lp-c"><ShieldCheck className="h-3.5 w-3.5" /> {fileName}</p>
        )}
        <button onClick={logout} data-testid="vault-unlock-logout" className="mt-4 flex w-full items-center justify-center gap-1.5 font-mono text-xs uppercase tracking-wider text-[#666] hover:text-[#a3a3a3]">
          <LogOut className="h-3 w-3" /> Esci
        </button>
      </div>
    </div>
  );
}
